module.exports = __webpack_public_path__ + "img/flavor_watermelon.d2eb3072.png";